// extracted by mini-css-extract-plugin
export default {"loader":"Modal_loader__uE7sZ"};